<template>
  <window v-for="(dialog, index) in dialogs" :key="dialog.data.windowId" :ref="'dialog' + index" v-model="dialog.data"
    :loading="loading" :parent="dialog.data.windowId" :domain="domain" :z-index="dialog.data.zIndex"
    @close-window="closeWindow(dialog.data.windowId)" @overlap-window="handleOverlapWindow"
    @min-window="minimizeWindow" />
</template>

<script>
import { defineAsyncComponent } from "vue";
const Window = defineAsyncComponent(() => import("@/components/core/Window"));
import { PrimeIcons } from "@primevue/core/api";

export default {
  components: { Window },
  provide() {
    return {
      props: this.props,
    };
  },
  data() {
    return {
      zindexIndex: 0,
      winCounter: 0,
      dialogs: [],
      domain: null,
      cIndex: null,
      loading: false,
    };
  },
  mounted() {
    this.emitter.on("open-gem", (event) => {
      this.openWindow(event.item);
      this.cIndex = event.item;
    });
    this.emitter.on("close-window", (event) => {
      this.closeWindow(event);
    });
    this.emitter.on("close-new", (event) => {
      this.openWindow(event);
    });
    this.emitter.on("add-gem", (event) => {
      this.openGemsWindow(event);
    });
    this.emitter.on("restore-window", this.restoreWindow);
  },
  methods: {
    openWindow(data) {
      this.loading = true;
      let props = { ...data };
      props.isVisible = true;
      props.windowId = ++this.winCounter;
      props.zIndex = ++this.zindexIndex;

      // let window = {
      //   data: props,
      // };
      this.dialogs.push({ data: props });
      this.loading = false;
    },

    openGemsWindow(data) {
      let tabId = 1;
      let props = {
        service: 1,
        key: "listing",
        label: "Add Gems",
        icon: PrimeIcons.PLUS_CIRCLE,
        tab_id: tabId,
      };
      this.openWindow(props);
    },

    closeWindow(windowId) {
      const idx = this.dialogs.findIndex(
        (dialog) => dialog.data.windowId === windowId,
      );
      if (idx >= 0) {
        this.dialogs[idx].data.isVisible = false;
        this.$nextTick(() => {
        this.dialogs.splice(idx, 1);
        this.minimizeWindow();
        if (this.dialogs.length > 0) {
          this.handleOverlapWindow(this.dialogs[this.dialogs.length - 1].data.windowId);
        }
        });
      }
    },

    toggleWindow(data) {
      data.data.isVisible = !data.data.isVisible;
    },

    handleOverlapWindow(windowId) {
      const dialog = this.dialogs.find((dlg) => dlg.data.windowId === windowId);
      if (dialog) {
        dialog.data.zIndex = ++this.zindexIndex;
      }
    },

    minimizeWindow(data) {
  const dialog = this.dialogs.find(
    (d) => d.data.windowId === data?.windowId,
  );
  if (dialog) {
    dialog.data.minimized = true;
    if (data?.label) dialog.data.label = data.label.trim();
  }
  this.emitter.emit(
    "minimized-windows",
    this.dialogs.filter((d) => d.data.minimized),
  );
},
    restoreWindow(windowId) {
      const dialog = this.dialogs.find((d) => d.data.windowId === windowId);
      if (!dialog) return;
      dialog.data.minimized = false;
      dialog.data.zIndex = ++this.zindexIndex;
      this.minimizeWindow();
    },

  },
};
</script>
<style scoped></style>
